<mat-card
    class="daxa-card recent-orders-card border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined"> search </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill"
                       placeholder="Chercher un échantillon..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <div class="btn-group">
                <button class="btn btn-outline-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                    <i class="fa-solid fa-plus px-2"></i> Nouveau
                </button>
                <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                    <i class="fa-solid fa-sliders px-2"></i>
                </button>
            </div>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

              <!-- Code échantillon -->
              <ng-container matColumnDef="sampleCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
                <td mat-cell *matCellDef="let e"> {{ e.sampleCode }} </td>
              </ng-container>

              <!-- Client -->
              <ng-container matColumnDef="clientName">
                <th mat-header-cell *matHeaderCellDef> Client </th>
                <td mat-cell *matCellDef="let e"> {{ e.clientName }} </td>
              </ng-container>

              <!-- Lot -->
              <ng-container matColumnDef="batchName">
                <th mat-header-cell *matHeaderCellDef> Lot </th>
                <td mat-cell *matCellDef="let e"> {{ e.batchName }} </td>
              </ng-container>

              <!-- Type analyse -->
              <ng-container matColumnDef="typeAnalyseName">
                <th mat-header-cell *matHeaderCellDef> Type analyse </th>
                <td mat-cell *matCellDef="let e"> {{ e.typeAnalyseName || '-' }} </td>
              </ng-container>

              <!-- Matrice -->
              <ng-container matColumnDef="matriceName">
                <th mat-header-cell *matHeaderCellDef> Matrice </th>
                <td mat-cell *matCellDef="let e"> {{ e.matriceName || '-' }} </td>
              </ng-container>

              <!-- Température réception -->
              <ng-container matColumnDef="temperatureReception">
                <th mat-header-cell *matHeaderCellDef> Température (°C) </th>
                <td mat-cell *matCellDef="let e"> {{ e.temperatureReception }} </td>
              </ng-container>

              <!-- Référence interne -->
              <ng-container matColumnDef="referenceInterne">
                <th mat-header-cell *matHeaderCellDef> Réf. interne </th>
                <td mat-cell *matCellDef="let e"> {{ e.referenceInterne }} </td>
              </ng-container>

              <!-- Date réception -->
              <ng-container matColumnDef="dateReception">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date réception </th>
                <td mat-cell *matCellDef="let e"> {{ e.dateReception | date:'short' }} </td>
              </ng-container>

              <!-- État échantillon -->
              <ng-container matColumnDef="sampleCondition">
                <th mat-header-cell *matHeaderCellDef> État échantillon </th>
                <td mat-cell *matCellDef="let e"> {{ e.sampleCondition }} </td>
              </ng-container>

              <!-- Conditions de stockage -->
              <ng-container matColumnDef="storageConditions">
                <th mat-header-cell *matHeaderCellDef> Stockage </th>
                <td mat-cell *matCellDef="let e"> {{ e.storageConditions }} </td>
              </ng-container>
              <ng-container matColumnDef="remarques">
                <th mat-header-cell *matHeaderCellDef> Remarques </th>
                <td mat-cell *matCellDef="let e"> {{ e.remarques }} </td>
              </ng-container>
              <!-- Actions (View uniquement) -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                  <td mat-cell *matCellDef="let element">
                      <div class="action-info text-center" style="justify-content: center !important;">

                          <button type="button" mat-button matTooltip="Visualiser les détails"
                                  matTooltipPosition="above" (click)="openViewSample(element)"
                          >
                              <i class="material-symbols-outlined">
                                  visibility
                              </i>
                          </button>
                          <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                  (click)="editReception(element)">
                              <i class="material-symbols-outlined text-primary">
                                  brush
                              </i>
                          </button>
                          <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                  (click)="confirmDelete(element)">
                              <i class="material-symbols-outlined text-danger">
                                  delete
                              </i>
                          </button>
                          <button type="button" mat-button matTooltip="Valider l'échantillon" matTooltipPosition="above"
                                (click)="validateSample(element)">
                          <i class="material-symbols-outlined text-success">
                            check_circle
                          </i>
                        </button>
                        <button mat-button matTooltip="Rejeter" color="warn" (click)="rejectSample(element)">
                          <i class="material-symbols-outlined">cancel</i>
                        </button>
                      </div>
                  </td>
              </ng-container>

              <!-- Header & Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>


          <div *ngIf="loadingTable">
            <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                <span class="skeleton-cell"></span>
            </div>
          </div>
          </div>
          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
          </div>
    </mat-card-content>
</mat-card>


<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Réception d'un échantillon</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submitReception()">
        <div class="row">

          <!-- Sélection d'un échantillon PRELEVEMENT -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Échantillon</mat-label>
              <mat-select formControlName="id" required>
                <mat-option *ngFor="let sample of prelevementSamples" [value]="sample.id">
                  {{ sample.sampleCode }} - {{ sample.typeSampleName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('id')?.hasError('required')">
                Échantillon requis
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Température réception -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Température réception</mat-label>
              <input matInput type="text" formControlName="temperatureReception">
            </mat-form-field>
          </div>
          <!-- Référence interne -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Référence interne</mat-label>
              <input matInput type="text" formControlName="referenceInterne">
            </mat-form-field>
          </div>
          <!-- Date réception -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Date et heure réception</mat-label>
              <input matInput type="datetime-local" formControlName="dateReception">
            </mat-form-field>
          </div>

          <!-- État échantillon -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>État échantillon</mat-label>
              <input matInput type="text" formControlName="sampleCondition">
            </mat-form-field>
          </div>

          <!-- Conditions de stockage -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Conditions de stockage</mat-label>
              <input matInput type="text" formControlName="storageConditions">
            </mat-form-field>
          </div>
        <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Remarques</mat-label>
              <input matInput type="text" formControlName="remarques">
            </mat-form-field>
          </div>
          <!-- Matrices -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Matrices</mat-label>
              <mat-select formControlName="matriceId" placeholder="Sélectionner la matrice"
                          (selectionChange)="fetchTypeAnalyseList()">
                <mat-option *ngFor="let mat of matriceList" [value]="mat.id">
                  {{ mat.nom }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('matriceId')?.hasError('required')">Champ requis</mat-error>
            </mat-form-field>
          </div>

          <!-- Type d'analyse -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Type d'analyse</mat-label>
              <mat-select formControlName="typeAnalyseId" (selectionChange)="fetchParametres()">
                <mat-option *ngFor="let st of typeAnalyseList" [value]="st.id">
                  {{ st.codeAT }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('typeAnalyseId')?.hasError('required')">Champ requis</mat-error>
            </mat-form-field>
          </div>

          <!-- Paramètres -->
          <div class="col-sm-12 pt-3 border-top p-3">
            <div class="fw-bold">Paramètres :</div>
            <div *ngIf="!form.get('matriceId')?.value || !form.get('typeAnalyseId')?.value"></div>
            <div *ngIf="form.get('matriceId')?.value && form.get('typeAnalyseId')?.value">
              <div *ngIf="paramList.length === 0">Aucun paramètre disponible pour ce type d'analyse.</div>
              <div *ngFor="let param of paramList; trackBy: trackByFn">
                <div class="row mt-3">
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Code Paramètre :</div>
                    <p>{{ param.codeParameter || param.pesticideName || 'N/A' }}</p>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Norme :</div>
                    <p>{{ param.description || 'N/A' }} </p>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Description :</div>
                    <p>{{ param.norme }} </p>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Technique :</div>
                    <p>{{ param.technique }} </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bouton d'enregistrement -->
          <div class="col-sm-12 text-right mt-3">
            <button type="submit" class="btn btn-outline-success">Enregistrer la réception</button>
          </div>

        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>




<ng-template #editModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Modifier échantillon</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="updateReception()">
  <div class="row">

    <!-- Type d'analyse -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Type d'analyse</mat-label>
        <mat-select formControlName="typeAnalyseId" required>
          <mat-option *ngFor="let type of typeAnalyseList" [value]="type.id">
            {{ type.codeAT || type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('typeAnalyseId')?.hasError('required')">
          Type d'analyse requis
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Matrice -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Matrice</mat-label>
        <mat-select formControlName="matriceId" required>
          <mat-option *ngFor="let matrice of matriceList" [value]="matrice.id">
            {{ matrice.nom }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('matriceId')?.hasError('required')">
          Matrice requise
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Température réception -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Température réception</mat-label>
        <input matInput type="text" formControlName="temperatureReception">
      </mat-form-field>
    </div>

    <!-- Référence interne -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Référence interne</mat-label>
        <input matInput type="text" formControlName="referenceInterne">
      </mat-form-field>
    </div>

    <!-- État échantillon -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>État échantillon</mat-label>
        <input matInput type="text" formControlName="sampleCondition">
      </mat-form-field>
    </div>

    <!-- Conditions de stockage -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Stockage</mat-label>
        <input matInput type="text" formControlName="storageConditions">
      </mat-form-field>
    </div>

    <!-- Date réception -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Date et heure réception</mat-label>
        <input matInput type="datetime-local" formControlName="dateReception">
      </mat-form-field>
    </div>

    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Remarques</mat-label>
        <input matInput type="text" formControlName="remarques">
      </mat-form-field>
    </div>
    <!-- Bouton sauvegarder -->
    <div class="col-12 mt-3">
      <button mat-raised-button color="primary" type="submit">
        Enregistrer
      </button>
    </div>

  </div>
</form>

    </mat-card-content>
  </mat-card>
</ng-template>


<!-- Modal template for infos -->
<ng-template #viewModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    
    <h5 class="fw-bold mx-3">
      Détails du Réception
    </h5>

    <div class="row m-3">
      <!-- Type d'analyse -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Type d'analyse :</div>
        <p>{{ getTypeAnalyseNameById(form.get('typeAnalyseId')?.value)  || '-' }}</p>
      </div>

      <!-- Matrice -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Matrice :</div>
        <p>{{ getMatriceNameById(form.get('matriceId')?.value) || '-' }}</p>
      </div>

      <!-- Température réception -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Température réception :</div>
        <p>{{ form.get('temperatureReception')?.value || '-' }}</p>
      </div>

      <!-- Référence interne -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Réf. interne :</div>
        <p>{{ form.get('referenceInterne')?.value || '-' }}</p>
      </div>

      <!-- Date réception -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date réception :</div>
        <p>{{ form.get('dateReception')?.value | date:'short' }}</p>
      </div>

      <!-- État échantillon -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">État échantillon :</div>
        <p>{{ form.get('sampleCondition')?.value || '-' }}</p>
      </div>

      <!-- Stockage -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Conditions de stockage :</div>
        <p>{{ form.get('storageConditions')?.value || '-' }}</p>
      </div>
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Remarques :</div>
        <p>{{ form.get('remarques')?.value || '-' }}</p>
      </div>

    </div>

  </mat-card>
</ng-template>



<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
